import { render } from "./GovDetail.vue?vue&type=template&id=31beca7f&scoped=true"
import script from "./GovDetail.vue?vue&type=script&lang=js"
export * from "./GovDetail.vue?vue&type=script&lang=js"

import "./GovDetail.vue?vue&type=style&index=0&id=31beca7f&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31beca7f"]])

export default __exports__